import * as React from 'react';
import { useState, useEffect } from 'react';
import { Admin, Resource, resolveBrowserLocale } from 'react-admin';
import polyglotI18nProvider from 'ra-i18n-polyglot';
import { MuiPickersUtilsProvider } from '@material-ui/pickers';
import DateFnsUtils from '@date-io/date-fns';
import { fr as frLocale } from 'date-fns/locale';
import englishMessages from './i18n/en';
import frenchMessages from './i18n/fr';

import './App.css';

import authProvider from './authProvider';
import themeReducer from './themeReducer';
import conversationsReducer from './chat/ConversationsReducer';
import { Login, Layout } from './layout';
import { Dashboard } from './dashboard';
import customRoutes from './routes';

import users from './users';
import posts from './posts';
import prducts from './prducts';
import pcs from './pcs';
import quizzes from './quizzes';
import submits from './submits';
import teams from './teams';
import videos from './videos';
import news_types from './news_types';
import knowledge from './knowledge';

import dataProviderFactory from './dataProvider';

const messages = {
    fr: frenchMessages,
    en: englishMessages,
};

const i18nProvider = polyglotI18nProvider(
    locale => (messages[locale] ? messages[locale] : messages.en),
    resolveBrowserLocale()
);

const App = () => {
    const [dataProvider, setDataProvider] = useState(null);

    useEffect(() => {
        let restoreFetch;

        const fetchDataProvider = async () => {
            const dataProviderInstance = await dataProviderFactory(
                process.env.REACT_APP_DATA_PROVIDER || ''
            );

            restoreFetch = dataProviderInstance;

            setDataProvider(
                // GOTCHA: dataProviderInstance can be a function
                () => dataProviderInstance
            );
        };

        fetchDataProvider();

        return restoreFetch;
    }, []);

    if (!dataProvider) {
        return (
            <div className="loader-container">
                <div className="loader">Chargement...</div>
            </div>
        );
    }

    return (
        <MuiPickersUtilsProvider utils={DateFnsUtils} locale={frLocale}>
            <Admin
                title=""
                dataProvider={dataProvider}
                customReducers={{
                    theme: themeReducer,
                    user: conversationsReducer,
                }}
                customRoutes={customRoutes}
                authProvider={authProvider}
                dashboard={Dashboard}
                loginPage={Login}
                layout={Layout}
                i18nProvider={i18nProvider}
            >
                <Resource name="users" {...users} />
                <Resource name="posts" {...posts} />
                <Resource name="prducts" {...prducts} />
                <Resource name="pcs" {...pcs} />
                <Resource name="quizzes" {...quizzes} />
                <Resource name="submits" {...submits} />
                <Resource name="teams" {...teams} />
                <Resource name="videos" {...videos} />
                <Resource name="news_types" {...news_types} />
            {/* <Resource name="knowledge" {...knowledge} /> */}
            </Admin>
        </MuiPickersUtilsProvider>
    );
};

export default App;
